import React, { useState, useEffect } from 'react';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
  const handleScroll = () => {
    const nav = document.querySelector('.nav');
    if (window.scrollY > 100) {
      nav?.classList.add('scrolled');
    } else {
      nav?.classList.remove('scrolled');
    }
  };
  
  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, []);

const handleSubmit = async (e) => {
  e.preventDefault();
  
  try {
    await fetch('https://script.google.com/macros/s/AKfycbyjshRSMn1joPZHTkIqhzdWiWOU-0MN2FRb5x1B5dGGXnjZsPhCOAXgoUcTaL8NcwJpqQ/exec', {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        source: 'newsletter-signup'
      })
    });
    
    alert(`Thanks for signing up! We'll send updates to ${email}`);
    setEmail('');
    
  } catch (error) {
    console.error('Signup error:', error);
    alert('Oops! Something went wrong. Please try again.');
  }
};

  const scrollToSection = (selector) => {
    setMenuOpen(false);
    setTimeout(() => {
      document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  // Realistic Glass Bottle Component
  const RealisticBottle = ({ flavor, primaryColor, secondaryColor, labelBg, available }) => (
    <div className="bottle-container">
      <div className="bottle-wrapper">
        {/* Bottle Cap */}
        <div className="bottle-cap">
          <div className="cap-top"></div>
          <div className="cap-ring"></div>
        </div>
        
        {/* Glass Bottle */}
        <div className="bottle-glass" style={{
          background: `linear-gradient(135deg, 
            ${primaryColor}15 0%, 
            ${secondaryColor}10 50%, 
            ${primaryColor}15 100%)`,
        }}>
          {/* Glass highlights */}
          <div className="glass-highlight"></div>
          <div className="glass-shine"></div>
          
          {/* Liquid inside */}
          <div className="bottle-liquid" style={{
            background: `linear-gradient(180deg, 
              ${primaryColor} 0%, 
              ${secondaryColor} 100%)`,
          }}></div>
          
          {/* Label */}
          <div className="bottle-label" style={{ background: labelBg }}>
            <div className="label-top-stripe" style={{ background: primaryColor }}></div>
            
            <div className="label-content">
              <div className="label-brand">
                <span className="label-sweaty" style={{ color: primaryColor }}>SWEATY</span>
                <span className="label-ass" style={{ color: secondaryColor }}>ASS</span>
              </div>
              
              <div className="label-subtitle">HOT SAUCE</div>
              
              <div className="label-flavor">{flavor}</div>
              
              <div className="label-heat">
                {[1,2,3,4,5].map(i => (
                  <div 
                    key={i} 
                    className="heat-dot" 
                    style={{ 
                      background: i <= 3 && available ? primaryColor : 'rgba(255,255,255,0.2)' 
                    }}
                  />
                ))}
              </div>
              
              <div className="label-info">5 FL OZ</div>
            </div>
          </div>
        </div>
        
        {/* Shadow */}
        <div className="bottle-shadow"></div>
      </div>
    </div>
  );

  return (
    <div className="app">
<style>{`
       @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Bungee+Shade&family=Rubik:wght@400;600;700&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

:root {
  --primary-orange: #FF6B1A;
  --navy-blue: #2C3E50;
  --golden-yellow: #FFB800;
  --cream: #FFF8E7;
  --white: #ffffff;
  --dark-charcoal: #1a1a1a;
  --medium-gray: #5a5a5a;
  --light-gray: #f5f5f5;
  --success-green: #27AE60;
}

body {
  font-family: 'Rubik', sans-serif;
  color: var(--dark-charcoal);
  overflow-x: hidden;
  background: var(--white);
}

        .app {
          background: var(--white);
        }

        /* Navigation */
      .nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: transparent;
  padding: 1.5rem 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  transition: background 0.3s ease;
}

.nav.scrolled {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

        .nav-logo {
          cursor: pointer;
          display: flex;
          align-items: center;
          border: none;
          padding: 0;
        }

        .nav-logo img {
          height: 80px;
          display: block;
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          padding: 0;
          margin: 0;
        }

        .nav-logo .sweaty {
          color: var(--primary-orange);
        }

        .nav-logo .ass {
          color: var(--golden-yellow);
        }

        .nav-menu {
          display: flex;
          gap: 3rem;
          list-style: none;
        }

.nav-item {
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--white);
  cursor: pointer;
  transition: color 0.3s ease;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.nav-item:hover {
  color: var(--golden-yellow);
}

.nav.scrolled .nav-item {
  color: var(--medium-gray);
  text-shadow: none;
}

.nav.scrolled .nav-item:hover {
  color: var(--primary-orange);
}

        /* Hamburger Menu */
.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;
  z-index: 1001;
}

.hamburger span {
  width: 28px;
  height: 3px;
  background: var(--white);
  transition: all 0.3s ease;
  border-radius: 2px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.nav.scrolled .hamburger span {
  background: var(--navy-blue);
  box-shadow: none;
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -7px);
}

/* Hero Video Section */
.hero {
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.hero-video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translate(-50%, -50%);
  object-fit: cover;
  z-index: 1;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
}

.hero-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  text-align: center;
  width: 90%;
  max-width: 1200px;
  padding: 0 2rem;
}

.hero-title {
  font-family: 'Bungee Shade', sans-serif;
  font-size: clamp(2.5rem, 9vw, 6rem);
  font-weight: 400;
  color: var(--primary-orange);
  letter-spacing: 0.05em;
  margin-bottom: 1rem;
  text-shadow: 
    3px 3px 0px rgba(0, 0, 0, 0.8),
    0 0 40px rgba(255, 107, 26, 0.5);
  line-height: 1.2;
  word-wrap: break-word;
  opacity: 0;
  animation: fadeInUp 1s ease-out 0.5s forwards;
}

.hero-tagline {
  font-family: 'Rubik', sans-serif;
  font-size: clamp(1.25rem, 3vw, 2rem);
  font-weight: 400;
  color: var(--white);
  letter-spacing: 0.05em;
  margin-bottom: 2.5rem;
  text-shadow: 
    2px 2px 4px rgba(0, 0, 0, 0.8),
    0 0 10px rgba(0, 0, 0, 0.5);
  opacity: 0;
  animation: fadeInUp 1s ease-out 1s forwards;
}

.hero-cta {
  display: inline-block;
  padding: 1.25rem 3.5rem;
  background: var(--primary-orange);
  color: var(--white);
  font-family: 'Rubik', sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(255, 107, 26, 0.4);
  opacity: 0;
  animation: fadeInUp 1s ease-out 1.5s forwards;
}

.hero-cta:hover {
  background: var(--golden-yellow);
  color: var(--navy-blue);
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(255, 184, 0, 0.5);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .hero-title {
    font-size: clamp(2.5rem, 8vw, 4rem);
  }
  
  .hero-tagline {
    font-size: clamp(1rem, 2.5vw, 1.5rem);
  }
  
  .hero-cta {
    padding: 1rem 2.5rem;
    font-size: 0.95rem;
  }
}

.cta-button {
  display: inline-block;
  padding: 1.25rem 3rem;
  background: var(--navy-blue);
  color: var(--white);
  font-family: 'Rubik', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(44, 62, 80, 0.3);
}

        .cta-button:hover {
          background: var(--golden-yellow);
          color: var(--navy-blue);
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(255, 184, 0, 0.4);
        }

        /* Features Section */
        .features {
          padding: 4rem 4rem;
          background: var(--white);
        }

        .features-grid {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 4rem;
        }

.feature-card {
  text-align: center;
  padding: 3rem 2rem;
  background: var(--white);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

        .feature-image {
          width: 100%;
          height: 300px;
          background: var(--cream);
          margin-bottom: 2rem;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 5rem;
        }

.feature-title {
  font-family: 'Rubik', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: var(--dark-charcoal);
}

        .feature-desc {
          font-size: 0.95rem;
          line-height: 1.8;
          color: var(--medium-gray);
          font-weight: 300;
        }

        /* Info Cards */
        .info-section {
          padding: 3rem 4rem;
          background: var(--light-gray);
        }

        .info-grid {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 3rem;
        }

.info-card {
  padding: 3rem 2rem;
  text-align: center;
  background: var(--white);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

        .info-icon {
          width: 80px;
          height: 80px;
          margin: 0 auto 1.5rem;
          background: linear-gradient(135deg, var(--primary-orange) 0%, var(--golden-yellow) 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          box-shadow: 0 4px 20px rgba(255, 107, 26, 0.3);
        }

.info-card h3 {
  font-family: 'Rubik', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: var(--dark-charcoal);
}

        .info-card p {
          font-size: 0.9rem;
          line-height: 1.7;
          color: var(--medium-gray);
        }

        /* Testimonials */
        .testimonials {
          padding: 4rem 4rem;
          background: var(--cream);
        }

.section-title {
  font-family: 'Bebas Neue', sans-serif;
  font-size: clamp(3rem, 7vw, 5rem);
  text-align: center;
  margin-bottom: 4rem;
  color: var(--primary-orange);
  letter-spacing: 0.05em;
  text-shadow: 3px 3px 0px var(--navy-blue);
}

        .testimonial-grid {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 3rem;
        }

.testimonial {
  background: var(--white);
  padding: 3rem 2rem;
  font-style: italic;
  color: var(--medium-gray);
  line-height: 1.8;
  border-left: 4px solid var(--primary-orange);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.testimonial:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

        .testimonial-author {
          margin-top: 1.5rem;
          font-style: normal;
          font-weight: 700;
          color: var(--navy-blue);
          font-size: 0.9rem;
        }

        /* Products Section */
.products {
  padding: 4rem 4rem;
  background: linear-gradient(135deg, var(--cream) 0%, #fff5d6 50%, var(--cream) 100%);
}

        .product-grid {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 3rem;
        }

.product-card {
  text-align: center;
  background: var(--white);
  padding: 3rem 2rem;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(255, 107, 26, 0.25);
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

        .product-bottle {
          width: 100%;
          height: 400px;
          margin-bottom: 2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        /* Realistic Bottle Styles */
        .bottle-container {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .bottle-wrapper {
          position: relative;
          width: 140px;
          height: 380px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        /* Bottle Cap */
        .bottle-cap {
          width: 50px;
          height: 30px;
          position: relative;
          z-index: 10;
          margin-bottom: -5px;
        }

        .cap-top {
          width: 50px;
          height: 22px;
          background: linear-gradient(135deg, #2c1810 0%, #4a2818 50%, #2c1810 100%);
          border-radius: 50% 50% 0 0 / 60% 60% 0 0;
          box-shadow: 
            0 2px 4px rgba(0,0,0,0.3),
            inset 0 -2px 2px rgba(0,0,0,0.2),
            inset 0 2px 2px rgba(255,255,255,0.1);
        }

        .cap-ring {
          width: 52px;
          height: 8px;
          background: linear-gradient(135deg, #3a2015 0%, #5a3020 50%, #3a2015 100%);
          border-radius: 2px;
          margin-top: -2px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.3);
        }

        /* Glass Bottle */
        .bottle-glass {
          position: relative;
          width: 130px;
          height: 350px;
          border-radius: 12px;
          backdrop-filter: blur(10px);
          box-shadow: 
            0 8px 32px rgba(0, 0, 0, 0.2),
            inset -4px 0 8px rgba(255, 255, 255, 0.1),
            inset 4px 0 8px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .glass-highlight {
          position: absolute;
          top: 10%;
          left: -10px;
          width: 30px;
          height: 50%;
          background: linear-gradient(90deg, 
            rgba(255,255,255,0.4) 0%, 
            rgba(255,255,255,0.1) 50%, 
            transparent 100%);
          border-radius: 50%;
          transform: rotate(-10deg);
          pointer-events: none;
        }

        .glass-shine {
          position: absolute;
          top: 5%;
          right: 10px;
          width: 15px;
          height: 40%;
          background: linear-gradient(180deg, 
            rgba(255,255,255,0.3) 0%, 
            transparent 100%);
          border-radius: 50%;
          pointer-events: none;
        }

        /* Liquid Inside Bottle */
        .bottle-liquid {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 75%;
          border-radius: 0 0 12px 12px;
          opacity: 0.85;
          box-shadow: inset 0 -20px 30px rgba(0,0,0,0.2);
        }

        /* Bottle Label */
        .bottle-label {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 88px;
          height: 180px;
          background: #2C3E50;
          border-radius: 4px;
          z-index: 5;
          box-shadow: 
            0 4px 12px rgba(0,0,0,0.4),
            inset 0 1px 1px rgba(255,255,255,0.1);
          overflow: hidden;
        }

        .label-top-stripe {
          width: 100%;
          height: 12px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }

        .label-content {
          padding: 12px 8px;
          text-align: center;
        }

        .label-brand {
          margin-bottom: 4px;
        }

.label-sweaty,
.label-ass {
  display: block;
  font-family: 'Rubik', sans-serif;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.05em;
  line-height: 1;
}

        .label-subtitle {
          font-size: 8px;
          letter-spacing: 0.3em;
          color: rgba(255,255,255,0.5);
          margin-bottom: 12px;
          font-weight: 300;
        }

        .label-flavor {
          font-size: 10px;
          color: rgba(255,255,255,0.9);
          line-height: 1.3;
          margin-bottom: 12px;
          min-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 300;
        }

        .label-heat {
          display: flex;
          gap: 4px;
          justify-content: center;
          margin-bottom: 12px;
        }

        .heat-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          border: 1px solid rgba(255,255,255,0.2);
        }

        .label-info {
          font-size: 7px;
          letter-spacing: 0.1em;
          color: rgba(255,255,255,0.4);
          margin-top: 8px;
        }

        /* Bottle Shadow */
        .bottle-shadow {
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 120px;
          height: 30px;
          background: radial-gradient(ellipse, rgba(0,0,0,0.4) 0%, transparent 70%);
          filter: blur(8px);
        }

        .product-badge {
          display: inline-block;
          padding: 0.5rem 1rem;
          background: var(--golden-yellow);
          color: var(--navy-blue);
          font-size: 0.75rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: 1rem;
          border-radius: 2px;
        }

        .product-card.coming-soon .product-badge {
          background: var(--navy-blue);
          color: var(--white);
        }

.product-name {
  font-family: 'Rubik', sans-serif;
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: var(--navy-blue);
}

        .product-price {
          font-size: 1.25rem;
          color: var(--primary-orange);
          font-weight: 700;
          margin-bottom: 1.5rem;
        }

.product-button {
  padding: 1rem 2.5rem;
  background: var(--primary-orange);
  color: var(--white);
  font-family: 'Rubik', sans-serif;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

        .product-button:hover {
          background: var(--golden-yellow);
          color: var(--navy-blue);
          transform: translateY(-2px);
        }

        /* Newsletter */
        .newsletter {
          padding: 3rem 4rem;
          background: var(--navy-blue);
          color: var(--white);
          text-align: center;
        }

.newsletter h2 {
  font-family: 'Bebas Neue', sans-serif;
  font-size: clamp(3rem, 7vw, 5rem);
  margin-bottom: 1rem;
  color: var(--primary-orange);
  letter-spacing: 0.05em;
  text-shadow: 3px 3px 0px rgba(0, 0, 0, 0.5);
}

        .newsletter p {
          font-size: 1.125rem;
          color: rgba(255, 255, 255, 0.7);
          margin-bottom: 3rem;
        }

        .newsletter-form {
          display: flex;
          max-width: 600px;
          margin: 0 auto;
          gap: 1rem;
        }

        .newsletter-input {
          flex: 1;
          padding: 1.25rem;
          border: 2px solid rgba(255, 255, 255, 0.2);
          background: transparent;
          color: var(--white);
          font-size: 0.95rem;
        }

        .newsletter-input::placeholder {
          color: rgba(255, 255, 255, 0.5);
        }

.newsletter-button {
  padding: 1.25rem 3rem;
  background: var(--primary-orange);
  color: var(--white);
  font-family: 'Rubik', sans-serif;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

        .newsletter-button:hover {
          background: var(--golden-yellow);
          color: var(--navy-blue);
          transform: translateY(-2px);
        }

/* Footer */
footer {
  padding: 4rem 2rem 2rem;
  background: var(--navy-blue);
  color: rgba(255, 255, 255, 0.7);
}

.footer-grid {
  max-width: 1200px;
  margin: 0 auto 3rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
}

.footer-column {
  text-align: left;
}

.footer-title {
  font-family: 'Rubik', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--white);
  margin-bottom: 1.5rem;
  letter-spacing: 0.05em;
}

.footer-email {
  display: inline-block;
  padding: 0.75rem 2rem;
  background: var(--primary-orange);
  color: var(--white);
  font-family: 'Rubik', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-email:hover {
  background: var(--golden-yellow);
  color: var(--navy-blue);
  transform: translateY(-2px);
}

.footer-social {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-social:hover {
  color: var(--golden-yellow);
  transform: scale(1.1);
}

.footer-social svg {
  width: 32px;
  height: 32px;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-link {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: var(--golden-yellow);
}

.footer-text {
  font-size: 0.85rem;
  line-height: 1.8;
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* Responsive - Desktop */
@media (max-width: 1024px) {
  .nav {
    padding: 1.5rem 2rem;
  }

  .features-grid,
  .info-grid {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}

@media (max-width: 768px) {
  .newsletter-form {
    flex-direction: column;
  }

  .features,
  .info-section,
  .testimonials,
  .products,
  .newsletter {
    padding: 4rem 2rem;
  }
}

/* MOBILE MENU - MUST BE ABSOLUTE LAST */
@media (max-width: 1024px) {
  .hamburger {
    display: flex !important;
  }
  
  .nav-menu {
    position: fixed !important;
    display: flex !important;
    top: 0 !important;
    right: -100% !important;
    width: 280px !important;
    height: 100vh !important;
    background: var(--white) !important;
    flex-direction: column !important;
    padding: 120px 2rem 2rem !important;
    gap: 0 !important;
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.3) !important;
    transition: right 0.4s ease !important;
    z-index: 999 !important;
  }
  
  .nav-menu.active {
    right: 0 !important;
  }
  
  .nav-item {
    font-size: 1.1rem !important;
    font-weight: 600 !important;
    padding: 1.25rem 0 !important;
    border-bottom: 1px solid var(--light-gray) !important;
    color: var(--navy-blue) !important;
    text-shadow: none !important;
  }
  
  .nav-item:hover {
    color: var(--primary-orange) !important;
    background: rgba(255, 107, 26, 0.05);
    padding-left: 0.5rem !important;
  }
  
  .nav-item:first-child {
    border-top: 1px solid var(--light-gray);
  }
}
      `}</style>

{/* Navigation */}
<nav className="nav">
  <div className="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
<img src="/logo.png" alt="Sweaty Ass Hot Sauce" />
  </div>
  
  <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
    <li className="nav-item" onClick={() => scrollToSection('.products')}>Shop</li>
    <li className="nav-item" onClick={() => scrollToSection('.features')}>About</li>
    <li className="nav-item" onClick={() => scrollToSection('.newsletter')}>Contact</li>
  </ul>
  
  <div className={`hamburger ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
    <span></span>
    <span></span>
    <span></span>
  </div>
</nav>

{/* Hero Video */}
<section className="hero">
  <video 
    autoPlay 
    loop 
    muted 
    playsInline 
    className="hero-video"
    controls={false}
    webkit-playsinline="true"
  >
    <source src="/hero-video.mp4" type="video/mp4" />
  </video>
  <div className="hero-overlay"></div>
  <div className="hero-content">
    <h1 className="hero-title">Sweaty Ass Hot Sauce</h1>
    <p className="hero-tagline">... It'll Make Your Ass Sweat!</p>
    <button className="hero-cta" onClick={() => scrollToSection('.products')}>
      Pick Your Sweat
    </button>
  </div>
</section>

      {/* Features */}
      <section className="features">
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-image">🔥</div>
            <h3 className="feature-title">Small Batch</h3>
            <p className="feature-desc">
              We craft our hot sauces in small batches to ensure every bottle delivers maximum flavor and quality.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-image">🥭</div>
            <h3 className="feature-title">Real Ingredients</h3>
            <p className="feature-desc">
              Fresh fruit, real peppers. No artificial flavors, no fillers, no BS. Ingredients you can actually pronounce.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-image">✨</div>
            <h3 className="feature-title">Funky Fusion</h3>
            <p className="feature-desc">
              We pair unexpected flavors to create hot sauces that make your taste buds question everything they thought they knew.
            </p>
          </div>
        </div>
      </section>

      {/* Info Cards */}
      <section className="info-section">
        <div className="info-grid">
          <div className="info-card">
            <div className="info-icon">🌶️</div>
            <h3>Heat Levels That Make Sense</h3>
            <p>From "your grandma could handle this" to "call your therapist," we've got a heat level for everyone.</p>
          </div>
          <div className="info-card">
            <div className="info-icon">🔥</div>
            <h3>Flavor First</h3>
            <p>We believe hot sauce should enhance your food, not punish it. Big flavor, then the heat kicks in.</p>
          </div>
          <div className="info-card">
            <div className="info-icon">🎯</div>
            <h3>Versatile AF</h3>
            <p>Tacos, eggs, pizza, ice cream (we don't judge). Our hot sauce works on everything.</p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials">
        <h2 className="section-title">What People Are Saying</h2>
        <div className="testimonial-grid">
          <div className="testimonial">
            "The mango pineapple combo hits sweet up front, then the habanero brings the heat. Been putting it on my chicken wings every weekend."
            <div className="testimonial-author">— Andre M.</div>
          </div>
          <div className="testimonial">
            "I'm usually skeptical of craft hot sauces, but these actually deliver. The flavors are complex, the heat is balanced, and the name makes me laugh every time I look at the bottle."
            <div className="testimonial-author">— John M.</div>
          </div>
          <div className="testimonial">
            "My grandkids bought this for me as a joke because of the name. Joke's on them - I use it on everything now."
            <div className="testimonial-author">— Roberta N.</div>
          </div>
        </div>
      </section>

      {/* Products */}
      <section className="products">
        <h2 className="section-title">Pick Your Sweat</h2>
        <div className="product-grid">
          <div className="product-card">
            <div className="product-bottle">
  <img 
    src="/mango-pineapple-bottle.png" 
    alt="Mango Pineapple Habanero" 
    style={{ 
      width: '100%', 
      height: '400px', 
      objectFit: 'contain'
    }} 
  />
</div>
            <div className="product-badge">Coming Soon</div>
            <h3 className="product-name">Mango Pineapple Habanero</h3>
            <p className="product-price">$12</p>
            <button className="product-button">Coming Soon</button>
          </div>
          
<div className="product-card coming-soon">
  <div className="product-bottle">
    <img 
      src="/blueberry-bottle.png" 
      alt="Blueberry Lemon Ghost Pepper" 
      style={{ 
        width: '100%', 
        height: '100%', 
        objectFit: 'contain',
        maxHeight: '400px'
      }} 
    />
  </div>
  <div className="product-badge">Coming Soon</div>
  <h3 className="product-name">Blueberry Lemon Ghost Pepper</h3>
  <p className="product-price">$12</p>
  <button className="product-button">Coming Soon</button>
</div>
          
          <div className="product-card coming-soon">
            <div className="product-bottle">
              <RealisticBottle 
                flavor="MYSTERY FLAVOR COMING SOON" 
                primaryColor="#FF1493" 
                secondaryColor="#FF6B00"
                labelBg="#0d0d0d"
                available={false}
              />
            </div>
            <div className="product-badge">Under Development</div>
            <h3 className="product-name">Mystery Flavor No. 3</h3> 
            <br></br>
            <br></br>
            <p className="product-price">$12</p>
            <button className="product-button">Coming Soon</button>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="newsletter">
        <h2>Join The Sweat List</h2>
        <p>Get notified when we release new flavors.</p>
        <form className="newsletter-form" onSubmit={handleSubmit}>
          <input
            type="email"
            className="newsletter-input"
            placeholder="your.email@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="newsletter-button">Sign Up</button>
        </form>
      </section>

      {/* Footer */}
{/* Footer */}
<footer>
  <div className="footer-grid">
    <div className="footer-column">
      <h4 className="footer-title">Get In Touch</h4>
      <a href="mailto:sweatyasshotsauce@gmail.com" className="footer-email">
        EMAIL US
      </a>
    </div>
    
<div className="footer-column">
  <h4 className="footer-title">Follow Us</h4>
  <a 
    href="https://instagram.com/sweatyasshotsauce" 
    target="_blank" 
    rel="noopener noreferrer"
    className="footer-social"
  >
    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  </a>
</div>
    
<div className="footer-column">
  <div className="footer-links">
    <span onClick={() => scrollToSection('.products')} className="footer-link" style={{cursor: 'pointer'}}>Shop</span>
    <span onClick={() => scrollToSection('.features')} className="footer-link" style={{cursor: 'pointer'}}>About Us</span>
    <span onClick={() => scrollToSection('.newsletter')} className="footer-link" style={{cursor: 'pointer'}}>Contact</span>
    <a href="/" className="footer-link">Privacy Policy</a>
  </div>
</div>
  </div>
  
  <p className="footer-text">
    © 2026 Sweaty Ass Hot Sauce. All Rights Reserved.<br />
    Made with questionable judgment and clean ingredients.
  </p>
</footer>
    </div>
  );
}
export default App;
